var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"globalSettins_page"},[_c('div',{staticClass:"status_list"},_vm._l((_vm.status_list),function(list,key){return _c('MonitoringStatusItem',{key:key,staticClass:"setting-item",attrs:{"list":list,"title":key},on:{"edit":_vm.new_API}})}),1)])
}
var staticRenderFns = []

export { render, staticRenderFns }